// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6776) return "static/chunks/6776.0440f85945ba4278.js";
	if (chunkId === 7024) return "static/chunks/7024.bddf824812afa831.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6723 ? "worker-chunks" : chunkId) + "-" + {"6723":"a3ea658959346be5","7209":"a725660549586a50","9588":"f35a2308afe85d2d"}[chunkId] + ".js";
};